import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Typography from "@material-ui/core/Typography";
import Chip from '@material-ui/core/Chip';
import moment from 'moment';
import { useGlobalState } from '../../../state';
import EnergyTooltip from '../components/materialTypeComponents/EnergyTooltip';
import { minChipLabelMobile } from '../../../views/FeedFormulation/utils/constants';
const useCardStyles = makeStyles(theme => ({
    card: {
        minWidth: 275,
        marginBottom: theme.spacing(2)
    },
    cardActionsContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    infoGrid: {
        marginBottom: theme.spacing(2)
    },
    label: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem'
    },
    value: {
        fontSize: '1rem',
        fontWeight: 500
    }
}));

const Mobile = ({data, viewDetails, onDelete, onEdit, onPaymentEdit, onGenerateInvoice, isProPlusVersion, amountObj}) => {
    const classes = useCardStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [{user}] = useGlobalState();

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete();
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit();
    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handlePaymentEdit = () => {
        setAnchorEl(null);
        onPaymentEdit();
    };

    const handleGenerateInvoice = () => {
        setAnchorEl(null);
        onGenerateInvoice();
    };

    const handleViewDetails = () => {
        setAnchorEl(null);
        viewDetails();
    };

    function calculateTotalAmount (rowData) {
        if (isProPlusVersion) {
            let totalAmount = 0
            let gstAmount = 0
            let tdsAmount = 0
            let tcsAmount = 0
            let billValue = 0
            if (rowData && rowData.purchaseMaterials) {
                let purchaseMaterials = rowData.purchaseMaterials
                purchaseMaterials.forEach(purchaseMaterial => {
                    let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst ? purchaseMaterial.gst : 0) / 100).toFixed(2))
                    let tdsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tds ? rowData.tds : 0) / 100).toFixed(2))
                    let tcsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tcs ? rowData.tcs : 0) / 100).toFixed(2))
                    gstAmount += gstTaxAmt
                    tdsAmount += tdsTaxAmt
                    tcsAmount += tcsTaxAmt
                    billValue += purchaseMaterial.billValue
                })
            }
            let gstTCSVal = gstAmount * (rowData.tcs/100)
            let totalTCS = Math.ceil(tcsAmount + gstTCSVal)
            totalAmount = billValue + totalTCS + gstAmount - tdsAmount
            return totalAmount.toLocaleString(user.locales,amountObj)
        } else { // pro version
            return (rowData.billValue).toLocaleString(user.locales,amountObj)
        }
    }

    function calculateRemainingBalance(rowData) {
        let totalAmount = 0
        let gstAmount = 0
        let tdsAmount = 0
        let tcsAmount = 0
        let billValue = 0
        let totalAmountPaid = 0
        if (rowData && rowData.purchaseMaterials) {
            let purchaseMaterials = rowData.purchaseMaterials
            purchaseMaterials.forEach(purchaseMaterial => {
                let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst ? purchaseMaterial.gst : 0) / 100).toFixed(2))
                let tdsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tds ? rowData.tds : 0) / 100).toFixed(2))
                let tcsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tcs ? rowData.tcs : 0) / 100).toFixed(2))
                gstAmount += gstTaxAmt
                tdsAmount += tdsTaxAmt
                tcsAmount += tcsTaxAmt
                billValue += purchaseMaterial.billValue
            })
        }
        if (rowData && rowData.purchasePayments && rowData.purchasePayments.length) {
            let purchasePayments = rowData.purchasePayments
            purchasePayments.forEach(ele => {
                if (ele.paymentMode !== -1 ) { // Exclude tax payment
                    totalAmountPaid += ele.paymentAmount
                }
            })
        }
        let gstTCSVal = gstAmount * (rowData.tcs/100)
        let totalTCS = Math.ceil(tcsAmount + gstTCSVal)
        totalAmount = billValue + totalTCS + gstAmount - tdsAmount
        
        let remainingAmount = totalAmount - totalAmountPaid;

        if (rowData.paymentStatus === 2 && remainingAmount < 1) {
            remainingAmount = 0
        }

        return remainingAmount.toLocaleString(user.locales,amountObj)
    }

    function calculateBillValue(rowData) {
        let billValue = 0
        if (rowData && rowData.purchaseMaterials) {
            let purchaseMaterials = rowData.purchaseMaterials
            purchaseMaterials.forEach(purchaseMaterial => {
                billValue += purchaseMaterial.billValue
            })
        }
        return billValue.toLocaleString(user.locales,amountObj)
    }

    return (
      <Grid item xs={12}>
        <Card className={classes.card}>
          <CardHeader
            action={
              <IconButton aria-label="settings" onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
            }
            title={`No: ${data.id || "N/A"}`}
            subheader={moment(data.date).format("DD/MM/YYYY")}
          />
          <CardContent>
            <Grid container spacing={2} className={classes.infoGrid}>
              {isProPlusVersion && (
                <Grid item xs={6}>
                  <Typography className={classes.label}>Customer</Typography>
                  <Typography className={classes.value}>
                    {data.vendorName || "N/A"}
                  </Typography>
                </Grid>
              )}
              {!isProPlusVersion && (
                <Grid item xs={6}>
                  <Typography className={classes.label}>Farm Name</Typography>
                  <Typography className={classes.value}>
                    {data.farmName || "N/A"}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={6}>
                <Typography className={classes.label}>Total Amount</Typography>
                <Typography className={classes.value}>
                  {calculateTotalAmount(data)}
                </Typography>
              </Grid>
            </Grid>

              {!isProPlusVersion && (
                <Grid item xs={12}>
                  <Typography className={classes.label}>Material Name</Typography>
                  <Grid container spacing={1} wrap='nowrap' style={{marginTop: '5px'}}>

                   {data?.purchaseMaterials?.map((material, index) => {
                            if(index < minChipLabelMobile){
                                return (

                                    <Grid item key={index}>
                                        <Chip
                                            label={material.materialName}
                                            color="primary"
                                            size='small'
                                        />
                                    </Grid>
                                )
                            }
                            return null;
                        })}

                       {
                            data?.purchaseMaterials?.length > minChipLabelMobile ?
                           <EnergyTooltip 
                            arrow={true}
                            title = {
                                <Grid container spacing={1}>
                                    {data?.purchaseMaterials?.map((material, index) => {
                                        if (index >= minChipLabelMobile){

                                            return (
    
                                                <Grid item key={index}>
                                                    <Chip
                                                        label={material.materialName}
                                                        color="primary"
                                                        size='small'
                                                    />
                                                </Grid>
                                            )
                                        }
                                        return null;
                                        
                                    })}
                                </Grid>
                            }
                             >
                            <Grid item>
                                <Chip size="small" color="primary" label={`+ ${data?.purchaseMaterials.length - minChipLabelMobile}`} />
                            </Grid>
                        </EnergyTooltip> :""
                        }
                  </Grid>
                </Grid>
              )}
            {isProPlusVersion && (
              <Grid container spacing={2} className={classes.infoGrid}>
                <Grid item xs={6}>
                  <Typography className={classes.label}>Bill Value</Typography>
                  <Typography className={classes.value}>
                    {calculateBillValue(data)}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.label}>Remaining Balance</Typography>
                  <Typography className={classes.value}>
                    {calculateRemainingBalance(data)}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography className={classes.label}>
                    Payment Status
                  </Typography>
                  <Chip
                    label={
                      data.paymentStatus === 0
                        ? "Not Paid"
                        : data.paymentStatus === 1
                        ? "Partially Paid"
                        : data.paymentStatus === 2
                        ? "Paid"
                        : "Pending"
                    }
                    color={
                      data.paymentStatus === 2
                        ? "primary"
                        : data.paymentStatus === 1
                        ? "secondary"
                        : "default"
                    }
                    size="small"
                    className={classes.chip}
                  />
                </Grid>
              </Grid>
            )}
          </CardContent>
        </Card>
        <Menu
          id="sale-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {viewDetails && (
            <MenuItem onClick={handleViewDetails}>Details</MenuItem>
          )}
          {onEdit && <MenuItem onClick={handleEdit}>Edit</MenuItem>}
          {onPaymentEdit && (
            <MenuItem onClick={handlePaymentEdit}>Payment</MenuItem>
          )}
          {onGenerateInvoice && (
            <MenuItem onClick={handleGenerateInvoice}>
              Generate Invoice
            </MenuItem>
          )}
          {onDelete && <MenuItem onClick={handleDelete}>Delete</MenuItem>}
        </Menu>
      </Grid>
    );
};

export default Mobile;